import { SearchRetargeting } from '../audience/SearchRetargeting';

export class KeywordContextual extends SearchRetargeting {}
